function setupEqualHeights() {

    function equalizeHeights() {
        const elements = document.querySelectorAll('.make-equal-height');
        if (elements.length === 0) return;

        elements.forEach(el => el.style.height = 'auto');

        let maxHeight = 0;
        elements.forEach(el => {
            const height = el.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        if (maxHeight > 0) {
            elements.forEach(el => {
                el.style.height = maxHeight + 'px';
            });
        }
    }

    setTimeout(equalizeHeights, 150);

    window.addEventListener('resize', function () {
        clearTimeout(window.equalHeightResize);
        window.equalHeightResize = setTimeout(equalizeHeights, 250);
    });

    window.equalizeHeights = equalizeHeights;
}

document.addEventListener('DOMContentLoaded', setupEqualHeights);
